"use strict";

exports.__esModule = true;
exports.AuditLogListToolbar = AuditLogListToolbar;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _Time = require("../../Time");
var _Calendar = require("../../Calendar");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AuditLogToolbar = (0, _styledComponents["default"])(_Core.Toolbar).withConfig({
  displayName: "AuditLogListToolbar__AuditLogToolbar",
  componentId: "sc-ivy0qt-0"
})(["display:flex;"]);
function AuditLogListToolbar() {
  var urlFilter = _react["default"].useContext(_Core.URLFilterContext);
  var reportingPeriod = _react["default"].useContext(_Time.ReportingPeriodContext);
  var _React$useContext = _react["default"].useContext(_Calendar.CalendarContext),
    calendar = _React$useContext.calendar;
  var time = _react["default"].useContext(_Time.TimeContext);
  var currentPlantWorkdayId = (0, _Calendar.getDate)(time.currentWorkday.interval.endMillis);
  var setFilter = urlFilter.setFilter;
  var start = (0, _Calendar.startOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.startMillis).id);
  var end = (0, _Calendar.endOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.endMillis - 1).id);
  return /*#__PURE__*/_react["default"].createElement(AuditLogToolbar, null, /*#__PURE__*/_react["default"].createElement(_Time.WorkdayRangeSelector, {
    maxDate: currentPlantWorkdayId,
    selected: [start, end],
    onSelect: function onSelect(selected) {
      if (selected.length === 0) {
        return;
      }

      // This can result in the days incrementing/decrementing from what the user selected
      var interval = calendar.getIntervalForWorkdays((0, _Calendar.toDateString)(selected));
      var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
      return setFilter("period", parts.join("/"));
    }
  }));
}